import React from 'react';
import TargetView from '../../components/enablement/TargetView';

const Targets = () => {
  return (
    <React.Fragment>
      <TargetView />
    </React.Fragment>
  );
};

export default Targets;
